import React from 'react';
import { RoomResult, PlayerResult } from '@shared/api-dto';
import { PromptFormat } from '@shared/constants';
import { getNextPrompt, getTeamName, getTeamUp, getRoundName, getRoundNumber, quote, isAllPlayPrompt } from '../shared/room-data-helpers';
import { Marquee, MarqueeItem, MarqueePlayer } from '../shared/marquee';
import { TeamPicker } from './team-picker';

type StartMoveMarqueeProps = {
  roomData: RoomResult;
  onComplete: () => void;
  nextPlayer?: PlayerResult;
  nextOpponent?: PlayerResult;
};

export const StartMoveMarquee = ({
  roomData,
  nextPlayer,
  onComplete,
  nextOpponent,
}: StartMoveMarqueeProps) => {
  if (roomData.currentMove) {
    return null;
  }

  const move = roomData.move;
  const teamUp = getTeamUp(roomData);
  const teamName = getTeamName(teamUp);
  const nextPrompt = getNextPrompt(roomData);
  const allPlay = isAllPlayPrompt(nextPrompt);
  const round = getRoundNumber(roomData);

  return (
    <Marquee key={'marquee_intro' + roomData.move} onComplete={onComplete}>
      {move === 1 && (
        <>
          <MarqueeItem key='pick_teams' duration={5000}>
            <TeamPicker players={roomData.players} />
          </MarqueeItem>
          <MarqueeItem key='get_ready' duration={1500}>
            {'Let\'s go!'}
          </MarqueeItem>
        </>
      )}
      {(teamUp === 1 || allPlay) && (
        <>
          <MarqueeItem key='marquee_round' duration={1500}>{`Round ${round}`}</MarqueeItem>
          <MarqueeItem duration={1500}>
            <div style={{ fontSize: '6rem' }}>{getRoundName(roomData)}</div>
          </MarqueeItem>
        </>
      )}
      {nextPrompt.type === PromptFormat.MULTIPLE_CHOICE && (
        <MarqueeItem key='marquee_team_up' duration={1500}>
          {`The ${teamName} team is up`}
        </MarqueeItem>
      )}
      {nextPrompt.type === PromptFormat.FREE_INPUT
        ? (
          <>
            <MarqueeItem key='player_up' duration={1750}>
              <MarqueePlayer team={nextPlayer?.team}>{nextPlayer?.user.name}</MarqueePlayer>{'\'s turn!'}
            </MarqueeItem>
            <MarqueeItem key='free_input' duration={4000}>
              <p>
                What did <MarqueePlayer team={nextOpponent?.team}>{nextOpponent?.user.name}</MarqueePlayer> say when asked:
              </p>
              <p className='actualAnswer'>
                <i>{quote(nextPrompt.text)}</i>
              </p>
            </MarqueeItem>
          </>
          )
        : (
          <MarqueeItem key='non_free_input' duration={2000}>
            Get ready {nextPlayer ? <MarqueePlayer team={nextPlayer.team}>{nextPlayer.user.name}</MarqueePlayer> : 'everybody'}!
          </MarqueeItem>
          )}
      {!allPlay && (
        <MarqueeItem duration={1500}>Everyone else: place your bets!</MarqueeItem>
      )}
      <MarqueeItem duration={500}>Ready?</MarqueeItem>
      <MarqueeItem duration={500}>STEADY!</MarqueeItem>
      <MarqueeItem duration={800}>GO!</MarqueeItem>
    </Marquee>
  );
};
